import * as ProprietarioOperations from './operations';
import ProprietarioReducer from './reducer';

export { ProprietarioOperations };

export default ProprietarioReducer;
